"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Form;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _Component = _interopRequireDefault(require("../../render/Component"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Validations = require("../../validations/Validations");

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _core = require("@material-ui/core");

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    component: {},
    titleContainer: {
      background: '#ee7f01',
      padding: '1vw'
    },
    title: {
      fontSize: '30px',
      color: 'white'
    },
    subtitle: {
      fontSize: '18px',
      color: 'white',
      paddingTop: '3em'
    },
    contentContainer: {
      padding: '0 1vw'
    },
    submitButton: {
      marginTop: '1em',
      marginBottom: '2em'
    },
    mandatory: {
      margin: '20px 0'
    },
    required: {
      color: 'red'
    },
    requiredText: {
      marginLeft: '4px'
    },
    button: {
      background: _cssConstants["default"] && _cssConstants["default"].colors && _cssConstants["default"].colors.buttonBackground ? _cssConstants["default"].colors.buttonBackground : 'red'
    }
  };
});

function Form(props) {
  var block = props.block,
      _props$block = props.block,
      formComponents = _props$block.content,
      style = _props$block.style,
      _props$block$hideSubm = _props$block.hideSubmitButton,
      hideSubmitButton = _props$block$hideSubm === void 0 ? false : _props$block$hideSubm,
      _props$block$isMandat = _props$block.isMandatory,
      isMandatory = _props$block$isMandat === void 0 ? false : _props$block$isMandat,
      _props$isPrecondition = props.isPreconditionData,
      isPreconditionData = _props$isPrecondition === void 0 ? false : _props$isPrecondition,
      parentPath = props.parentPath,
      onSubmit = props.onSubmit,
      _props$isAutoSave = props.isAutoSave,
      isAutoSave = _props$isAutoSave === void 0 ? false : _props$isAutoSave,
      _props$successfullySu = props.successfullySubmitted,
      successfullySubmitted = _props$successfullySu === void 0 ? false : _props$successfullySu;
  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var isValid;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _Validations.validateForm)(parentPath, _GenericStore.dataStore, block);

            case 2:
              isValid = _context.sent;

              if (isValid) {
                onSubmit();
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  var form = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.contentContainer, " ctnForm")
  }, block && block.title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: 'formTitle'
  }, block.title) : null, isMandatory && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mandatory
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.required
  }, "*"), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.requiredText
  }, t('TXT_MANDATORY'))), formComponents.map(function (component, ind) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.component
    }, /*#__PURE__*/_react["default"].createElement(_Component["default"], {
      block: component,
      number: ind + 1,
      parentPath: parentPath,
      store: _GenericStore.dataStore,
      onSubmit: handleSubmit,
      key: parentPath + (component.path ? component.path : ''),
      isAutoSave: isAutoSave,
      isPreconditionData: isPreconditionData
    }));
  }), !hideSubmitButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.submitButton, " ctnFormSubmit")
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: 'contained',
    color: 'primary',
    onClick: successfullySubmitted ? function () {} : handleSubmit,
    className: 'btnSubmitButton',
    classes: {
      root: classes.button
    }
  }, successfullySubmitted ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    style: {
      color: 'green'
    }
  }) : 'Absenden'))));

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, style === 'card' ? /*#__PURE__*/_react["default"].createElement(_core.Card, {
    style: {
      padding: '10px'
    }
  }, form) : form);
}